<template>
    <div class="layout">
        <section class="layout-container">
            <header class="layout-header">
                <div class="layout-header-l">{{ $store.state.enterpriseInfo.name }}</div>
                <ul class="layout-header-r t-right">
                    <li class="layout-header-r-item">
                        <router-link to="/task">
                            <el-badge :value="taskData.count">
                                <svg
                                    width="20px"
                                    height="20px"
                                    viewBox="0 0 20 20"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                >
                                    <path
                                        d="M9.15648738,1.47728505 C9.3313254,1.65196127 9.5923464,1.88932255 9.59314016,2.13715147 L9.59314016,3.21627731 L10.6298713,3.41823662 C12.5440945,3.82999086 13.9157737,5.52525093 13.9273497,7.49359456 L13.9273497,12.5516202 L14.4009875,12.9133384 C15.0326954,13.3936715 15.5151844,14.2429425 15.7919238,14.9891151 L1.14752637,14.9891151 C1.42426579,14.2429425 1.96730463,13.3936715 2.59901253,12.9133384 L3.07265032,12.5516202 L3.07265032,7.49359456 C3.08422632,5.52525093 4.45590546,3.82999086 6.37012873,3.41823662 L7.44016655,3.21627731 L7.44016655,2.13715147 C7.44827405,1.62381123 7.98794798,1.21056761 8.49850115,1.20567656 C8.7449644,1.20492647 8.98164936,1.30260884 9.15648738,1.47728505 Z M8.49850115,0 C7.32556545,0.00330258168 6.37506629,0.957722337 6.37012873,2.13715147 L6.37012873,2.23963828 C3.89864354,2.76581431 2.12630148,4.95335622 2.11338389,7.49359456 L2.11338389,11.9547852 C0.84523688,12.9196563 0.0705404533,14.4024978 0,16 L17,16 C16.9281681,14.4036827 16.1536491,12.9222856 14.8866161,11.9577995 L14.8866161,7.49359456 C14.8748347,4.95294661 13.101985,2.76477824 10.6298713,2.23963828 L10.6298713,2.13715147 C10.6249253,0.956549185 9.67260701,0.00164768846 8.49850115,0 Z"
                                        fill="#333333"
                                        fill-rule="nonzero"
                                    ></path>
                                    <path
                                        d="M6,17 C6,18.1045695 7.11928813,19 8.5,19 C9.88071187,19 11,18.1045695 11,17"
                                        stroke="#333333"
                                        stroke-linejoin="round"
                                    ></path>
                                </svg>
                            </el-badge>
                        </router-link>
                    </li>
                </ul>
            </header>
            <main class="layout-main">
                <router-view :key="$route.fullPath" />
            </main>
            <footer class="layout-footer">
                Copyright © {{ new Date().getFullYear() }}
                {{ this.$store.state.enterpriseInfo.name }}, All Rights Reserved.
            </footer>
        </section>
        <aside class="layout-sider">
            <div class="layout-logo">
                <router-link to="/personal">
                    <el-avatar
                        shape="circle"
                        :size="32"
                        :src="$store.state.userInfo.avatar || require('../assets/img/logo.svg')"
                    ></el-avatar>
                </router-link>
            </div>
            <ul class="layout-menu">
                <template v-for="(route, index) in routeData">
                    <template v-if="route.children">
                        <template v-if="route.children.length">
                            <li
                                :key="index"
                                class="layout-menu-item"
                                @mouseover="$navigationOver"
                                @mouseleave="$navigationLeave"
                            >
                                <router-link :to="route.path">
                                    <i :class="route.icon"></i>
                                </router-link>
                                <v-menu :menuData="route.children" />
                            </li>
                        </template>
                        <template v-else>
                            <li :key="index" class="layout-menu-item">
                                <router-link :to="route.path">
                                    <i :class="route.icon"></i>
                                </router-link>
                            </li>
                        </template>
                    </template>
                </template>
            </ul>
            <ul class="layout-control">
                <li class="layout-control-item">
                    <router-link to="/exit">
                        <i class="anticon anticon-poweroff"></i>
                    </router-link>
                </li>
            </ul>
        </aside>
    </div>
</template>

<script>
import Push from 'push.js'
import Menu from '@/components/Menu'
export default {
    components: {
        'v-menu': Menu
    },
    data() {
        return {
            routeData: [],
            taskData: {
                count: 0
            },
            remindData: {
                list: []
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.$router.options.routes.forEach(row => {
                if (row.path === '/') {
                    this.routeData = row.children
                }
            })
            if (this.$route.path === '/') {
                this.$router.replace({
                    path: '/dashboard'
                })
            }
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.GetCount()
            this.GetRemind()
            setInterval(() => {
                this.GetRemind()
            }, 60000)
        })
    },
    watch: {
        'remindData.list'(val) {
            val.forEach(item => {
                Push.create('待处理任务提醒', {
                    body: item.visit_remind_memo,
                    requireInteraction: true,
                    timeout: 4000
                })
            })
        }
    },
    methods: {
        GetCount() {
            this.$request({
                url: '/api/v1/getcount'
            }).then(res => {
                if (!res.status) {
                    if (res.data.count) {
                        this.taskData.count = res.data.count
                        Push.create('待处理任务提醒', {
                            body: res.data.count + ' 个待处理任务，赶快完成吧',
                            requireInteraction: true,
                            timeout: 4000
                        })
                    }
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetRemind() {
            this.$request({
                url: '/api/v1/ajaxgetremind'
            }).then(res => {
                if (!res.status) {
                    this.remindData.list = res.data.list
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
.layout {
    display: flex;
    min-height: 100vh;
    padding-left: 80px;
    &-sider {
        display: flex;
        flex-direction: column;
        min-width: 80px;
        height: 100vh;
        background-color: #001529;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2000;
    }
    &-logo {
        display: flex;
        height: 64px;
        align-items: center;
        justify-content: center;
        color: #fff;
        position: relative;
        a {
            display: flex;
            &:hover {
                filter: grayscale(30%);
            }
        }
    }
    &-menu,
    &-control {
        &-item {
            display: flex;
            margin-right: -4px;
            border-right: 4px solid transparent;
            align-items: center;
            color: rgba(255, 255, 255, 0.65);
            position: relative;
        }
        a {
            display: flex;
            width: 100%;
            height: 40px;
            margin: 4px 0;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #a8adb4;
            cursor: pointer;
            &:hover,
            &.router-link-active {
                color: #fff;
            }
            &-selected {
                background-color: #001529;
                color: #fff;
            }
        }
    }
    &-menu {
        padding: 15px 0;
        font-size: 14px;
        flex: 1;
        > .layout-menu-item {
            > .layout-menu-item {
                background: #303750;
            }
        }
    }
    &-container {
        display: flex;
        flex-flow: column;
        flex: 1;
        width: 100vh;
        background-color: #f0f2f5;
        // overflow-y: auto;
    }
    // container
    &-header {
        display: flex;
        align-items: center;
        min-height: 64px;
        padding: 0 20px;
        // box-shadow: 0 2px 7px 0 rgba(0, 0, 0, .11);
        box-shadow: 0 1px 4px rgba(0, 21, 41, 0.01);
        // box-shadow: 0 8px 28px rgba(72, 89, 102, .1);
        background-color: #fff;
        font-size: 14px;
        color: #333;
        &-l,
        &-r {
            flex: 1;
        }
        &-r {
            &-item {
                margin-right: 10px;
            }
        }
        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: rgba(0, 0, 0, 0.85);
            &:hover {
                color: @color-primary;
            }
        }
        .el-avatar {
            width: 32px;
            margin-right: 10px;
            border-radius: 9999px;
        }
        .anticon {
            font-size: 18px;
        }
    }
    &-main {
        flex: 1;
        padding: 20px;
        h1 {
            margin: auto;
        }
    }
    &-footer {
        padding-bottom: 20px;
        font-size: 12px;
        text-align: center;
        color: rgba(0, 0, 0, 0.3);
    }
}
</style>
